export default __webpack_public_path__ + "static/media/title-pensando-em-voz-alta.691e2443.png";